import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Pressable,
  ScrollView,
  Dimensions,
  PixelRatio,
  BackHandler,
  Alert,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import t from "@constants/localization";
import { actions as authActions } from "@reducers/authReducer";
import RadioInactive from "../../assets/svg/RadioInactive";
import Button from "../../components/Button";
import { setLang, getLang } from "../../services/api";
import HeaderWithBackAndTitle from "../../components/HeaderWithBackAndTitle";
import RadioActive from "../../assets/svg/RadioActive";
import testIds from "@constants/testIds";

const PATH = "screens/LanguageSelection";

const defaultLang = [
  { icon: "", id: "hi", is_active: true, label: "हिंदी", value: "hi" },
  { icon: "", id: "en", is_active: true, label: "English", value: "en" },
];

function normalize(size) {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
}

const { width } = Dimensions.get("window");
const scale = width / 360;

const LanguageSelection = ({ navigation, route }) => {
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.auth.user);
  const [langSelected, setLangSelected] = useState(language);
  const [langLabel, setLangLabel] = useState("");
  const [langOptions, setLangOptions] = useState(defaultLang);
  const onLangChange = (LangKey) => {
    if (language === LangKey) {
      return;
    }
    setLang({ language: LangKey })
      .then(() => {
        dispatch(authActions.setLanguage(LangKey));
        navigation.reset({
          index: 0,
          routes: [
            {
              name: "HomeStack",
            },
          ],
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getLang().then(({ data }) => {
      if (data.languages) {
        setLangOptions(data.languages);
        for (let i = 0; i < data.languages.length; i++) {
          if (data.languages[i].value === langSelected) {
            setLangLabel(data.languages[i].label);
          }
        }
      }
    });
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <HeaderWithBackAndTitle
        headertitle={t(`${PATH}/selectLanguage`)}
        headerColor={route.headerColor || "#fff"}
        hideShadow={route.hideShadow || false}
        navigation={navigation}
        leftIcon={route.leftIcon}
        onCloseNavigateTo={route.onCloseNavigateTo}
        dynamicTitleRead={route.dynamicTitleRead}
        rightIcon={route.rightIcon}
        shouldEmitEvent={route.shouldEmitEvent}
        headerStyle={{ fontSize: normalize(20) }}
        route={route}
      />
      <View
        testID={testIds.lang_selection_container}
        style={styles.modalContainer}
      >
        <View>
          <Text style={{ fontFamily: "NotoSansDevanagari-SemiBold" }}>
            {t(`${PATH}/pleaseSelectALanguage`)}
          </Text>
        </View>
        <ScrollView
          style={{ marginTop: 10, flex: 1 }}
          showsVerticalScrollIndicator={false}
        >
          {langOptions.map((obj, i) => (
            <Pressable
              testID={obj.id}
              key={i}
              onPress={() => {
                setLangSelected(obj.value);
                setLangLabel(obj.label);
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  flexGrow: 1,
                  justifyContent: "space-between",
                  margin: 5,
                  paddingVertical: 15,
                  paddingHorizontal: 10,
                  borderColor:
                    obj.value === langSelected ? "#E40046" : "rgba(0,0,0,0.2)",
                  borderWidth: 1,
                  borderRadius: 6,
                  backgroundColor:
                    obj.value === langSelected
                      ? "rgba(228, 0, 70, 0.1)"
                      : "#fff",
                }}
              >
                <Text
                  style={{
                    color: "black",
                    textAlign: "center",
                    fontFamily: "NotoSansDevanagari-Regular",
                  }}
                >
                  {obj.label}
                </Text>
                {obj.value === langSelected ? (
                  <RadioActive />
                ) : (
                  <RadioInactive />
                )}
              </View>
            </Pressable>
          ))}
        </ScrollView>
        <Button
          testID={testIds.enter_new_lang}
          btnText={t(`${PATH}/selectThisLanguage`, { lang: langLabel })}
          buttonWidth={width - 45}
          buttonStyle={{ borderRadius: 6, margin: 3 }}
          onPress={() => {
            onLangChange(langSelected);
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "white",
    padding: 20,
    flex: 1,
  },
});

export default LanguageSelection;
